import { Typography } from 'antd'
import cls from 'classnames'
import { useAtom } from 'jotai'
import React from 'react'
import { Link } from 'react-router-dom'

import { getNameLink } from '@/components/special-project-relations.component'
import { departmentsAtom } from '@/modules/department'
import { routes } from '@/router'
import { ProjectWeekWorkResourceSnapshotType } from '@/schemas'

export const ProjectDetailTable: React.FC<{
  list: {
    project: { selfId: string; name: string; resourceType: ProjectWeekWorkResourceSnapshotType }
    orders: {
      order: number
      departmentId: number
      projectWorkload: number
      departmentWorkload: number
      percentage: number
    }[]
    departmentProjectWorkload: number
    totalDepartmentWorkload: number
    percentage: number
  }[]
  type?: 'team' | 'big-project'
}> = ({ list, type = 'team' }) => {
  const [departments] = useAtom(departmentsAtom)
  const startDate = new URLSearchParams(window.location.search).get('startDate')
  const endDate = new URLSearchParams(window.location.search).get('endDate')

  return (
    <div className='space-y-4 h-75 overflow-x-hidden overflow-y-auto'>
      {list.map((item, index) => (
        <div key={item.project.selfId}>
          <div className='flex font-medium text-base mb-2 justify-between'>
            <Typography.Text
              className={type === 'big-project' && index !== 0 ? 'text-sm font-medium ml-4' : ''}
              ellipsis={{ tooltip: item.project.name }}
            >
              {item.project.resourceType === ProjectWeekWorkResourceSnapshotType.SPECIFIC_PROJECT_CUSTOM
                ? item.project.name
                : getNameLink({
                    name: item.project.name,
                    type: item.project.resourceType as any,
                    selfId: item.project.selfId,
                    params: { tab: 'dashboard', startDate, endDate },
                  })}
            </Typography.Text>
            <div
              className={cls('flex flex-shrink-0 ml-8', type === 'big-project' && index !== 0 ? 'text-sm ml-4' : '')}
            >
              <div>
                {item.departmentProjectWorkload} / {item.totalDepartmentWorkload}
              </div>
              <div className='text-right ml-2 w-20'>({(item.percentage * 100).toFixed(1)}%)</div>
            </div>
          </div>
          <div className='space-y-2 pl-2'>
            {item.orders.map((p) => (
              <div key={p.departmentId} className='flex justify-between'>
                <Typography.Text ellipsis={{ tooltip: departments.find((d: any) => d.id === p.departmentId)?.name }}>
                  <Link
                    to={routes.team.home({ departmentId: p.departmentId, tab: 'dashboard', startDate, endDate })}
                    target='_blank'
                  >
                    <span className='ml-4'>{departments.find((d: any) => d.id === p.departmentId)?.name}</span>
                  </Link>
                </Typography.Text>
                <div className='flex flex-shrink-0 ml-8'>
                  <div>
                    {p.projectWorkload} / {p.departmentWorkload}
                  </div>
                  <div className='text-right ml-2 w-20'>({(p.percentage * 100).toFixed(1)}%)</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  )
}
